export default __webpack_public_path__ + "static/media/punchDescriptionThumbnail.781cbf3a.svg";